// helpers
import { format } from 'd3-format';
import { wrapLongLabels } from './utils/helpers';
import { cnn_red, defaults, politics } from './utils/colors';

// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    data,
    height,
    initialWidth,
    initialHeight,
    margins,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 3 : 5;
  const comma = format(',');
  const fmtSI = format('.2s');

  const darkColors = {
    rep: politics.rep[0],
    dem: politics.dem[0],
    nat: politics.lib[0],
  };

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.right]})`);

  const xGrid = g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .style('display', 'none')
    .call(xAxis(x).ticks(xTicks).tickFormat(d => `$${fmtSI(d)}`));

  xGrid.selectAll('text')
    .attr('y', 5);

  xGrid.selectAll('line')
    .attr('y2', -height);

  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y));

  yGrid.selectAll('text')
    .attr('transform', 'translate(-9,0)')
    .call(wrapLongLabels, margins.left);

  const bar = g.append('g')
    .attr('class', 'bars')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'bar')
    .attr('transform', d => `translate(${[x(Math.min(0, d.amt)), y(d.label)]})`);

  bar.append('rect')
    .attr('width', d => Math.abs(x(d.amt) - x(0)))
    .attr('height', y.bandwidth())
    .attr('fill', d => (d.amt > 0 ? darkColors[d.party] : defaults.gray7));

  bar.append('text')
    .attr('transform', (d) => {
      const x0 = d.amt < 0 ? 5 : Math.abs(x(d.amt) - x(0)) + 5;
      const y0 = y.bandwidth() / 2;
      return `translate(${[x0, y0]})`;
    })
    .attr('dy', '.35em')
    .text(d => `$${fmtSI(d.amt)}`);

  const lines = g.append('g')
    .attr('class', 'lines');

  lines.append('line')
    .attr('x1', x(x.domain()[0]))
    .attr('x2', x(x.domain()[1]))
    .attr('y1', height)
    .attr('y2', height);

  // zero bar for negative values
  if (x.domain()[0] < 0) {
    lines.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', x(0))
      .attr('x2', x(0))
      .attr('y2', height);
  }
}
